import type { RefObject } from 'react';
import { slideUpFadeIn } from '../../../util/animation/slide/slide';

interface FooterListRefs {
  listItemsRef: RefObject<Array<HTMLElement> | null>;
}

export function setupFooterListTransition(
  timeline: gsap.core.Timeline,
  { listItemsRef }: FooterListRefs,
): gsap.core.Timeline {
  timeline.add(slideUpFadeIn(listItemsRef.current as Array<HTMLElement>, { stagger: 0.05 }));

  return timeline;
}
